import React                          from 'react';
import Button                         from '@material-ui/core/Button';
import Dialog                         from '@material-ui/core/Dialog';
import Request                        from 'superagent';
import AppBar                         from '@material-ui/core/AppBar';
import Toolbar                        from '@material-ui/core/Toolbar';
import IconButton                     from '@material-ui/core/IconButton';
import Slide                          from '@material-ui/core/Slide';
import Typography                     from '@material-ui/core/Typography';
//import Tooltip from '@material-ui/core/Tooltip';
import Card                           from '@material-ui/core/Card';
import CardContent                    from '@material-ui/core/CardContent';
import Icono                          from './Icono';
import {globales,funciones}           from '../global';
import AuthService                    from '../AuthService';
import { withStyles }                 from '@material-ui/core/styles';
import ButtonGroup                    from '@material-ui/core/ButtonGroup';
import DialogContent                  from '@material-ui/core/DialogContent';
import DialogTitle                    from '@material-ui/core/DialogTitle';
import VisibilityTwoToneIcon          from '@material-ui/icons/VisibilityTwoTone';
import CircularProgress               from '@material-ui/core/CircularProgress';
import Backdrop                       from '@material-ui/core/Backdrop';
//import { TramRounded } from '@material-ui/icons';

let Auth = new AuthService();
var movil=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

var url_reporte;
var parametros_reporte;


  /*                           CLASES DE ESTILO                       */

  var styles = theme =>({
    Dialog:{
      //position: 'absolute'
    },
    closeButton:{
      position: 'absolute',
      right: 0,
      top:2,
    },
    Backdrop:{
    zIndex:        2000,
    color:         'white',
    flexDirection: 'column',
    background:'rgba(0,0,0,0.8)',
    position: 'absolute'
    }
  })

 function Button2(props){
  return(
    <Button id={props.id} variant={props.variant} color={props.color} onClick={props.handleClickOpen} style={{textTransform:'none',display: props.boton === false?"none":"auto"}}>
      <Icono icono='Drive'/>
      {props.name_button}
  </Button>
  );
}
     


 /*                                        EXPORT                                      */
export default withStyles(styles)(
  class FullScreenDialog extends React.Component {
//export default function FullScreenDialog(props) {

  constructor(props) {

    super(props);
     this.Auth = new AuthService();
  
     this.parametros_valores=props.parametros;
     this.name_button=props.nom_boton;
     this.titulo_bar=props.nom_bar;
     this.color_bar=props.color_bar;
     this.backcolor=props.backcolor;
     this.variant_b = props.variant;
     this.color_b = props.color;
     this.fill_b = props.fill;
     this.fullScreen = props.fullScreen;
     this.boton = props.boton;
     this.tipo = props.tipo;
     this.label_reporte = props.label_reporte;
     this.id = props.id;
     this.opciones = props.opciones;
     this.state = {
        open:               false,
        isLoggin :          undefined,
        url: '',
        cargando:false,
        open_report: false,
        tipo_documento: '',
     }
    }; //FIN CONSTRUCTORS
 // var [open, setOpen] = React.useState(false);
 // document.oncontextmenu = ()=>{return false;}

 URL_reporte=(reporte,parametros_valores,tipo)=> {
  this.setState({cargando:true},()=>{
  try{
    Request.get(`${globales.ip}/generar_token_knowage/${reporte}/${this.Auth.getProfile().rol}/${Auth.getProfile().plataforma===2?'PDF':tipo}`)
    .set({'authorization': 'Bearer ' + Auth.getToken() })
    .end(async (err, res)=>{ 
        const tmp = JSON.parse(res.text);
        if (tmp.URL!=='') //SI HAY REGISTROS
        {
          url_reporte= tmp.URL;
          parametros_reporte= tmp.PARAMETROS;
          if(parametros_reporte!=='' && parametros_reporte!==undefined)
          {
            var param = parametros_reporte.split(',');
            var param_valor = parametros_valores.split(',');
            for(var x=0; x<param.length; x++)
            {
              url_reporte=url_reporte+'&'+param[x]+'='+param_valor[x];
            }
          }
    
        if(!movil){
          if(tipo==='XLS'){
          funciones.showToast('i','Generando archivo, no cierre la ventana "Tipo Documento".<br/> Puede tardar un momento...')
          }
          this.setState({url: url_reporte, cargando:tipo!=='XLS'?true:false, tipo_documento: tipo, open_report: tipo!=='XLS'?true:false});
        }     
        else
        {
            var windowSize = "width=" + window.innerWidth + ",height=" + window.innerHeight + ",scrollbars=no";
            this.setState({cargando: false},()=>{window.open(url_reporte, 'Reporte', windowSize);  })
        }   
      } 
      else{
        funciones.showToast('w','No se encontro el reporte.')
        this.setState({cargando: false});
      }                   
  })
  }
  catch(ex){
    this.setState({cargando: false})
  }
})
}

handleClickOpenReport= (tipo) => event =>{
  this.URL_reporte(this.props.label_reporte,this.props.parametros,tipo)
}

handleCloseReport= () => event =>{
  this.setState({open_report: false,cargando:false,tipo_documento:'',url:''});
}

  
handleClickOpen= () => event =>{
  //console.log(Auth.getProfile().plataforma)
  //console.log(this.opciones)
  if(Auth.getProfile().plataforma===2 || (this.opciones===undefined?false:!this.opciones))
  {
    
    this.URL_reporte(this.props.label_reporte,this.props.parametros,'PDF')
  }
  else
  {
    this.setState({open: true});
  }
    
}
handleClose= () => event =>{
   this.setState({open: false,cargando:false,tipo_documento:'',url:''});
}


componentDidMount()
{
        //let _this = this;
        Auth.loggedIn().then( function(b){
         // _this.setState({ isLoggin: b})
        })
}

componentDidUpdate(prevProps, prevState,snapshot){

  if (this.props.parametros !== prevProps.parametros || (this.state.open!==prevState.open && prevState.open===false)) {
    this.parametros_valores= this.props.parametros;
    
    //this.URL_reporte(this.props.label_reporte,this.props.parametros,this.props.tipo)
  }

  if(this.props.opciones !== prevProps.opciones)
  this.opciones=this.props.opciones;

  if(this.props.label_reporte !== prevProps.label_reporte)
  this.label_reporte=this.props.label_reporte;

  if(this.props.nom_bar !== prevProps.nom_bar)
  this.titulo_bar=this.props.nom_bar;
}

/*                                          RENDER                          */
render() {

    const { classes } = this.props;

    //console.log(this.state.url)

//if (this.state.isLoggin === true )
//{

    return(
      <div>
      {this.state.cargando && this.state.open?
      <Backdrop open={true} className={classes.Backdrop}>
        <CircularProgress color="inherit" />
        <span style={{marginTop: '10px' }}>{'Cargando...'}</span>
      </Backdrop>:null}
      <Button2 id={this.id} variant={this.variant_b} color={this.color_b} handleClickOpen={this.handleClickOpen()} name_button={this.name_button} fill={this.fill_b} boton={this.boton}/>
      <Dialog maxWidth='xs' fullWidth={true} open={this.state.open} onEscapeKeyDown={this.handleClose()} TransitionComponent={Transition} classes = {{ paper: classes.Dialog}}>
      <DialogTitle >
      <Typography >{"Tipo de Documento"}</Typography>
      <IconButton size="small" color="inherit" onClick={this.handleClose()} className={classes.closeButton} style={{backgroundColor: this.backcolor===undefined?"auto":this.backcolor}}>
        <Icono icono='Close' fontSize="small" />
      </IconButton>
      </DialogTitle>
      <DialogContent style={{margin:0}}>
        <ButtonGroup disableElevation  variant="outlined" color="primary" style={{marginBottom:20,width: '100%',justifyContent:'center'}}>
        <Button style={{color: 'green',textTransform:'none'}} onClick={this.handleClickOpenReport('XLS')}
        startIcon={<svg style={{width:'24px', height:'24px'}} viewBox="0 0 24 24"><path fill="currentColor" d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z" /></svg>}
        >Excel</Button>
        <Button style={{color: 'red',textTransform:'none'}} onClick={this.handleClickOpenReport('PDF')}
        startIcon={<svg style={{width:'24px', height:'24px'}} viewBox="0 0 24 24"><path fill="currentColor" d="M13,9H18.5L13,3.5V9M6,2H14L20,8V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2M10.1,11.4C10.08,11.44 9.81,13.16 8,16.09C8,16.09 4.5,17.91 5.33,19.27C6,20.35 7.65,19.23 9.07,16.59C9.07,16.59 10.89,15.95 13.31,15.77C13.31,15.77 17.17,17.5 17.7,15.66C18.22,13.8 14.64,14.22 14,14.41C14,14.41 12,13.06 11.5,11.2C11.5,11.2 12.64,7.25 10.89,7.3C9.14,7.35 9.8,10.43 10.1,11.4M10.91,12.44C10.94,12.45 11.38,13.65 12.8,14.9C12.8,14.9 10.47,15.36 9.41,15.8C9.41,15.8 10.41,14.07 10.91,12.44M14.84,15.16C15.42,15 17.17,15.31 17.1,15.64C17.04,15.97 14.84,15.16 14.84,15.16M7.77,17C7.24,18.24 6.33,19 6.1,19C5.87,19 6.8,17.4 7.77,17M10.91,10.07C10.91,10 10.55,7.87 10.91,7.92C11.45,8 10.91,10 10.91,10.07Z" /></svg>}
        >PDF</Button>
        <Button style={{textTransform:'none'}} onClick={this.handleClickOpenReport('PRINT')} startIcon={<VisibilityTwoToneIcon />}
        >Vista</Button>
        </ButtonGroup>
        {
          this.state.tipo_documento==='XLS'?
          <embed onLoad={()=>{this.setState({cargando:false})}}  src={this.state.url} style={{visibility:'hidden',height: 0,width:0,padding:0,margin:0}} />:null
        }
      </DialogContent>
      </Dialog>
      <Dialog fullWidth={true} maxWidth="xl" fullScreen={this.fullScreen}
      open={this.state.open_report} onClose={this.handleCloseReport()} TransitionComponent={Transition}
      style={{display: 'block', zIndex: 600000}} >
        <Card style={{borderRadius:0,overflow:'hidden'}}>
          <AppBar id="barra" color={this.color_bar}  
          style={{borderRadius:0,borderBottomRightRadius: 0,padding:0,position: 'relative', backgroundColor: this.backcolor===undefined?"auto":this.backcolor}}>
            <Toolbar variant="dense" style={{ minHeight:'auto',padding:2,paddingLeft:20}}>
              <IconButton size="small" color="inherit" onClick={this.handleCloseReport()} style={{backgroundColor: this.backcolor===undefined?"auto":this.backcolor}}>
                <Icono icono='Close' fontSize='small' />
              </IconButton>
              <Typography variant="h6" style={{flexGrow: 1, marginLeft:20}} color="inherit">{this.titulo_bar}</Typography> 
            </Toolbar>
          </AppBar>
          <CardContent style={{position:'absolute',bottom:0,top:27,left:0,right:0}}>
          <div id="view" style={{width:"100%" ,overflow:'hidden'//, height: window.innerHeight-90
          ,position:'absolute',bottom:0,top:0,left:0,right:0}}>
          {this.state.cargando?
            <Backdrop open={true} className={classes.Backdrop} style={{position:'absolute'}}>
              <CircularProgress color="inherit" />
              <span style={{marginTop: '10px' }}>{'Cargando...'}</span>
            </Backdrop>:null}
              <embed onLoad={()=>{this.setState({cargando:false})}} src={this.state.url} id="Reporte" title='Reporte' frameBorder="0" width="100%" height="100%" />
          </div>
          </CardContent>
            </Card>
        </Dialog>
        </div>
    )
 // }
//  else if (this.state.isLoggin === false)
//  {
 //   Auth.logout()
 //   window.location.reload();
 //   return; 
  //}
  
  
  //return null;
  } /// finaliza render
  } /// finaliza class
  )/// finaliza withStyles